import { useState } from 'react';
import { toast } from 'sonner';
import { apiDownloadBlob } from '../api/client';

export function useBlobDownload() {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadBlob = async (path: string, filename: string, label: string): Promise<boolean> => {
    setIsDownloading(true);
    const toastId = toast.loading(`Esportazione ${label} in corso...`);
    try {
      await apiDownloadBlob(path, filename);
      toast.success(`${label} scaricato`, { id: toastId });
      return true;
    } catch (e) {
      toast.error(e instanceof Error ? e.message : `Errore download ${label}`, { id: toastId });
      return false;
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadBlob };
}
